( function () {
	'use strict';

	function ObsFiltersCtrl ( $scope, _, logger, TOOLTIP_MESSAGES ) {
		var self = this;

		self.tooltip = TOOLTIP_MESSAGES;

		function setFilter () {
			_.forEach( $scope.saveTags, function ( val ) {
				if ( val[ self.filterName ] ) {
					self.filter = val[ self.filterName ][ 0 ];
				}
			} );
		}

		if ( $scope.saveTags ) {
			self.filterName = _.keys( $scope.filters )[ 0 ];
			$scope.selected = $scope.saveTags;

			setFilter();
		}

		function selectFilter ( key, val ) {
			self.tempObj = {};

			self.filter         = val;
			self.tempObj[ key ] = [ val ];

			if ( !$scope.selected.length ) {
				return $scope.selected.push( self.tempObj );
			}

			var exist = _.find( $scope.selected, function ( value, index ) {
				if ( value[ self.tags ] !== undefined ) {
					return $scope.selected.splice( index, 1, self.tempObj );
				}
			} );

			if ( !exist ) {
				$scope.selected.push( self.tempObj );
			}
		}

		function activate () {
			logger.info( 'Activated Observation Filters View' );
		}

		activate();

		self.selectFilter = selectFilter;
		self.setFilter    = setFilter;
	}

	angular
		.module( 'app.observations' )
		.controller( 'ObsFiltersCtrl', ObsFiltersCtrl );

	ObsFiltersCtrl.$inject = [ '$scope', '_', 'logger', 'TOOLTIP_MESSAGES' ];
} )( );
